import React from 'react';
import { useFavorites, useIsFavorite } from '../../hooks/useFavorites';
import FavoriteButton from './FavoriteButton';

const FavoriteButtonHooked = ({ titleId }) => {
    const { isFavorite, setIsFavorite } = useIsFavorite(titleId);
    // eslint-disable-next-line no-unused-vars
    const { addFavorite, removeFavorite } = useFavorites();

    return (
        <FavoriteButton
            titleId={titleId}
            isFavorite={isFavorite}
            addFavorite={addFavorite}
            removeFavorite={removeFavorite}
            setIsFavorite={setIsFavorite}
        />
    );
};

export default FavoriteButtonHooked;
